// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-bg{background:hsla(0,0%,100%,.3);width:100vw;height:100vh;position:fixed;top:0;left:0;z-index:999999}.loading-bg img{display:block;position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;width:15%}", ""]);
// Exports
module.exports = exports;
